import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import "react-phone-input-2/lib/bootstrap.css";
import "react-phone-input-2/lib/style.css";
import logowhite from "../../../assets/images/logowhite.svg";
import uplodimg from "../../../assets/images/upload.png";
import downloaddimg from "../../../assets/images/download.svg";
import { userService, utilService } from "services";
import useCurrentUser from "hooks/useCurrentUser";
import SignatureModal from "components/Modals/SignatureModal";
import LoaderIndicator from "components/LoaderIndicator";
import Images from "assets/images";

const Step3 = () => {
  const [error, setError] = useState(null);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [fileNames, setFileNames] = useState({});
  const [contractDoc, setContractDoc] = useState(null);
  const [showSignModal, setShowSignModal] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const signRef = useRef();
  const navigate = useNavigate();
  const { user, setUser: setCurrentUser } = useCurrentUser();
  const LIVE_SITE_URL = process.env.REACT_APP_LIVE_SITE_URL;
  const formik = useFormik({
    initialValues: {
      step: "3",
      contractAgreement: "",
      signature: "",
    },
    validationSchema: Yup.object().shape({
      contractAgreement: Yup.string().required(
        "Please upload contract agreement"
      ),
      signature: Yup.string().required("Please upload signature"),
    }),
    onSubmit: async (values) => {
      if (!isTermsAccepted) {
        setError("Please accept terms and conditions!");
        return;
      }
      try {
        const response = await userService.buildPilotProfile(values);
        localStorage.setItem("userData", JSON.stringify(response?.data?.data));
        setCurrentUser(response?.data?.data);
        navigate("/dashboard");
      } catch (err) {
        console.error(err?.response?.data?.message);
        setError(err?.response?.data?.message);
      }
    },
  });

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const extension = file.name.split(".").pop();

    try {
      setIsUploading(true);
      const response = await utilService.getBucketUrl({
        location: "users/",
        extension,
      });
      const webUrlData = response.data.data[0];
      const { filename, preview, url } = webUrlData || {};

      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
        },
        body: file,
        redirect: "follow",
      };

      const result = await utilService.uploadFile({
        url,
        requestOptions,
      });
      formik.setFieldValue(e.target.name, filename);
      setFileNames({
        ...fileNames,
        [e.target.name]: file.name,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setIsUploading(false);
    }
  };

  const handleTerms = (e) => {
    setIsTermsAccepted(e.target.checked);
    setError(null);
  };

  const handleApi = async () => {
    try {
      const response = await utilService.getContractAgreement();
      setContractDoc(response.data.data?.url);
    } catch (err) {
      console.log(err);
    }
  };

  const closeHandler = () => {
    setShowSignModal(false);
  };

  const handleCreateSign = () => {
    const url = signRef.current.getTrimmedCanvas().toDataURL("image/png");
    formik.setFieldValue("signature", url);
    closeHandler();
  };

  useEffect(() => {
    handleApi();
  }, []);

  const handleDownload = (url) => {
    fetch(url).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "agreement.pdf";
        alink.click();
      });
    });
  };

  return (
    <div className="container-fluid login-page p-0">
      <div className="row relative">
        <div className="col-lg-7 pr-0">
          <div className="right-login-side">
            <div className="nav-bar-container">
              <Link to="/" className="nav-bar">
                <img alt="" src={Images.arrowleft} className="me-2 py-1" />
                Home
              </Link>
            </div>

            <div className="outer-div-form">
              <div className="form-div profile-form mb-5">
                <div className="tab-content-bg">
                  <div className="auth-tab-content authcontainer px-lg-5 px-3">
                    <div>
                      <p className="step-p">Step 3 of 3</p>
                      <div className="d-flex justify-content-between gap-2">
                        <div className="step-lines active"></div>
                        <div className="step-lines active"></div>
                        <div className="step-lines active"></div>
                      </div>
                    </div>
                    <h4 className="text-capitalize text-center form-hreading fw-bold text-white">
                      Complete Profile
                    </h4>
                    <form>
                      <div className="mb-30 text-left">
                        <label className="py-2">Contractor Agreement </label>
                        {contractDoc && (
                          <a
                            className="d-flex d-files-div justify-content-center align-items-center cursor-pointer"
                            onClick={() =>
                              handleDownload(`${user?.baseS3Url}${contractDoc}`)
                            }
                          >
                            <p className="mb-0 pe-2 text-blue">
                              Contractor Agreement
                            </p>
                            <img alt="" src={downloaddimg} className="color-white-img" />
                          </a>
                        )}
                        <div className="upload-card ">
                          <label className="uploadFile">
                            {isUploading ? (
                              <LoaderIndicator />
                            ) : (
                              <img alt="" src={uplodimg} />
                            )}
                            <p>
                              {formik.values.contractAgreement
                                ? fileNames?.contractAgreement
                                : isUploading
                                  ? "Uploading..."
                                  : "Upload Contractor Agreement"}
                            </p>
                            <input
                              type="file"
                              className="inputfile form-control"
                              name="contractAgreement"
                              onChange={handleFileUpload}
                              onBlur={formik.handleBlur}
                            />
                          </label>
                        </div>
                        {formik.touched.contractAgreement &&
                          formik.errors.contractAgreement ? (
                          <span className="text-danger">
                            {formik.errors.contractAgreement}
                          </span>
                        ) : null}
                      </div>

                      <div className="mb-30 text-left">
                        <label className="py-2">Signature</label>
                        <div
                          className="upload-card"
                          onClick={() => setShowSignModal(true)}
                        >
                          <label className="uploadFile">
                            <p>
                              {formik.values.signature ? (
                                <img src={formik.values.signature} alt="sign" />
                              ) : (
                                "Add your signature"
                              )}
                            </p>
                          </label>
                        </div>
                        {formik.touched.signature && formik.errors.signature ? (
                          <span className="text-danger">
                            {formik.errors.signature}
                          </span>
                        ) : null}
                      </div>

                      <div className="form-check align-items-start">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          defaultValue
                          id="flexCheckDefault"
                          onChange={(e) => handleTerms(e)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault"
                        >
                          <p className="my-0">
                            By clicking here, the pilot is understanding this is
                            legally binding. The pilot is acknowledging the
                            information provided herein to be true and accurate.
                            Failure to provide correct information can result in
                            immediate suspension and or legal action. Skyytask is not
                            responsible for any misinformation provided by a user in
                            any medium and will not be held accountable for such.
                          </p>
                        </label>
                      </div>
                      {error && <div className="text-danger">{error}</div>}
                      <div className="text-center ">
                        <button
                          type="button"
                          className="btn btn-primary text-capitalize"
                          onClick={formik.handleSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="d-flex mt-md-0 mt-2 flex-md-row flex-column bottom-ft justify-content-between auth-bottom-links">
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-start justify-content-center">
                  <Link to={`${LIVE_SITE_URL}terms-conditions`}>Terms of Services</Link>
                  <Link to={`${LIVE_SITE_URL}privacy-policy`}>Privacy Policy</Link>
                </div>
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-end justify-content-center">
                  <p>© 2023 SkyyTask. All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-5 pl-0 pr-0 pt-0">
          <div className="left-bg-form">
            <div className="logo-container w-100">
              <Link to="/" className="mx-auto mt-4 d-flex justify-content-center">
                <img alt="" src={logowhite} className="logo" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <SignatureModal
        show={showSignModal}
        closeHandler={closeHandler}
        signRef={signRef}
        handleCreateSign={handleCreateSign}
      />
    </div>
  );
};

export default Step3;
